<template>
  <!-- If there's only one link, no need to have the dropdown -->
  <div
    v-if="links.length === 1"
    :class="['helpCenterButton', {'is-logged-out': isLoggedOut}]">
    <button :class="['help-center-btn el-dropdown-link']" @click="handleButtonClick(links[0])"></button>
  </div>

  <el-dropdown
    v-else-if="links.length > 1"
    :class="['helpCenterButton', {'is-logged-out': isLoggedOut}]"
    trigger="click"
    refs="helpCenterButton"
    placement="bottom-end"
    @command="handleButtonClick"
    @visible-change="active = !active">
    <button :class="['help-center-btn el-dropdown-link', {'active': active}]"></button>
    <template #dropdown>
      <el-dropdown-menu class="help-center-dropdown-menu py-[10px]!">
        <el-dropdown-item class="help-center-dropdown-items px-5! py-[7px]!" v-for="link in links" :key="link" :command="link">
          <template v-if="link === 'legal'">{{ $t('legal.legal') }}</template>
          <template v-else>{{ $t(`label.${link}`) }}</template>
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script src="./help-center-button.js"></script>
<style lang="scss" src="./help-center-button.scss"></style>
